/**
 * OFf Canvas Navigation
 **/
export const OffCanvas = function( $ ) {

	const module = {

		elements: {
			$offCanvas: $( '#off-canvas-panel' ),
			$offCanvasToggle: $( '.js--off-canvas-open' ),
		},

		offCanvasSettings: {
			containerSelector: 'body',
			direction: 'right',
			duration: 300,
			transition: 'ease-in-out',
			distanceX: '20rem',
			enableEscapeKey: true,
		},

		/**
		 * Initialize the plugin.
		 */
		init: function() {
			this.elements.$offCanvas.scotchPanel( this.offCanvasSettings );
		},

		/**
		 * Open
		 */
		open: function() {
			this.elements.$offCanvas.open();
		},

		/**
		 * Close
		 */
		close: function() {
			this.elements.$offCanvas.close();
		},

	};

	module.init();

	module.elements.$offCanvasToggle.click( function( e ) {

		const $this = $( this );

		if ( $this.hasClass( 'open' ) ) {
			$this.removeClass( 'open' );
			$this.find( 'span' ).text( CFN.text.topics );
			$this.find( '[data-fa-i2svg]' ).removeClass( 'fa-times' );
			$this.find( '[data-fa-i2svg]' ).addClass( 'fa-bars' );
			module.close();
		} else {
			$this.addClass( 'open' );
			$this.find( 'span' ).text( CFN.text.close );
			$this.find( '[data-fa-i2svg]' ).addClass( 'fa-times' );
			$this.find( '[data-fa-i2svg]' ).removeClass( 'fa-bars' );
			module.open();
		}
	} );

	return module;

}( jQuery );
